
// bootstrap
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';



const CustomTooltip = (props) => {

    const text = props.text

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={props.placement ?? "right"}
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
        >
            {props.children}
        </OverlayTrigger>
    );
};

export default CustomTooltip;